import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';

import { Card } from '@mui/material';
import { DEFAULT_TOOLBAR_OPTIONS } from 'constants/editor.constants';
import { ContentState, EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { Editor } from 'react-draft-wysiwyg';

import { replaceAltForImg } from 'helpers/editor.helper';

const WYSIWYGEditor = ({ value, onChange, toolbarOptions = DEFAULT_TOOLBAR_OPTIONS }) => {
  const contentBlocks = htmlToDraft(value);
  const [editorState, setEditorState] = useState(() =>
    contentBlocks
      ? EditorState.createWithContent(
        ContentState.createFromBlockArray(contentBlocks)
      )
      : EditorState.createEmpty()
  );

  // useEffect(() => {
  //   // console.log({ editorState, content: editorState.getCurrentContent() });
  //   // let html = convertToHTML(editorState.getCurrentContent());
  //   let html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
  //   onChange(html);
  // }, [editorState]);


  const onEditorStateChange = useCallback((editorValue) => {
    setEditorState(editorValue);
    const html = draftToHtml(convertToRaw(editorValue.getCurrentContent()));
    const formattedHtmlContent = replaceAltForImg(html)
    onChange(formattedHtmlContent);
  }, []);

  return (
    <Card sx={{
      minHeight: '400px', '.rdw-image-modal-size:not(:has(.rdw-image-modal-alt-lbl))': {
        display: 'none',
      },
    }}>
      <Editor
        editorState={editorState}
        wrapperClassName="wrapper-class"
        editorClassName="editor-class"
        toolbarClassName="toolbar-class"
        editorStyle={{
          border: '1px solid grey',
          maxHeight: '400px',
          minHeight: '400px',
        }}
        onEditorStateChange={onEditorStateChange}
        toolbar={toolbarOptions}
        handlePastedText={() => false}
      />
    </Card>
  );
};

WYSIWYGEditor.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  toolbarOptions: PropTypes.object
};

WYSIWYGEditor.defaultProps = {
  value: '',
  onChange: () => {},
};

export default WYSIWYGEditor;
